// Shared Google Maps loader and visual presets. Keeping this lightweight lets
// preview-only maps reuse the exact loader options without importing operational
// GIS services and socket dependencies.
export const MAP_LIBRARIES = ['drawing', 'places'];

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'script-loader',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDIaHtdtmv9P4cickkhrxeoxRd1GiwbKN4',
  version: 'quarterly',
  libraries: MAP_LIBRARIES,
};

const DARK_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#1d2c4d' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8ec3b9' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1a3646' }] },
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#4b6878' }] },
  { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#023e58' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#283d6a' }] },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#304a7d' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#98a5be' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#2c6675' }] },
  { featureType: 'transit', elementType: 'labels.text.fill', stylers: [{ color: '#98a5be' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0e1626' }] },
];

const LIGHT_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cfe8ff' }] },
];

const PLAIN_MAP_STYLE = [
  { elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
];

export const MAP_STYLE_PRESETS = {
  standard: { label: 'Standard', mapTypeId: 'roadmap', styles: [] },
  light: { label: 'Light', mapTypeId: 'roadmap', styles: LIGHT_MAP_STYLE },
  dark: { label: 'Dark', mapTypeId: 'roadmap', styles: DARK_MAP_STYLE },
  plain: { label: 'Plain (no labels)', mapTypeId: 'roadmap', styles: PLAIN_MAP_STYLE },
  satellite: { label: 'Satellite', mapTypeId: 'satellite', styles: [] },
  hybrid: { label: 'Hybrid', mapTypeId: 'hybrid', styles: [] },
};

export const buildMapStyleOptions = (key, extra = {}) => {
  const preset = MAP_STYLE_PRESETS[key] || MAP_STYLE_PRESETS.standard;
  return {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: true,
    mapTypeId: preset.mapTypeId,
    styles: preset.styles,
    ...extra,
  };
};
